import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { IFROportunitats } from './oportunitats.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class OportunitatsService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };


  public get(primer, quants, filters = {}, conds = {}, ordering = {}, exportar = false): Observable<any> {
   let params = new HttpParams();
  
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    params = params.append('export', exportar.toString());

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<IFROportunitats[]>(APIURLConstantsService._API_BASE_URL + 'oportunitats?primer='+primer+'&quants='+quants, this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getOportunitats(idClientSoci): Observable<IFROportunitats[]> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'oportunitats/' + idClientSoci, this.options)
      .pipe(map(response => response || []));
  }
  
  public createOportunitats(data): Observable<any> {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'oportunitats', data)
      .pipe(map(response => response || {}));
  }

  public updateOportunitats(id, data): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'oportunitats/'+id, data)
      .pipe(map(response => response || {}));
  }
  
  public deleteOportunitats(id): Observable<any> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'oportunitats/'+id)
      .pipe(map(response => response || {}));
  }

  public sendMessage(To, Subject, Content): Observable<any>{
    let params = new HttpParams();
  
    params = params.append("To", To.toString().replace(/\+/g,"%2B"));
    params = params.append("Subject", Subject.toString().replace(/\+/g,"%2B"));
    params = params.append("Content", Content.toString().replace(/\+/g,"%2B"));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

  return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'sendmail', this.options).pipe(map(response => {
       return response || [];
    }));
  }

  public converteixProposta(data): Observable<any>{
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'convertoppro', data)
      .pipe(map(response => { return response || {} }));
  };

  public converteixPreProposta(data){
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'convertoppre', data)
      .pipe(map(response => { return response || {} }));
  };
  
  constructor(private authHttp: HttpClient) { }

}
